import { mixed, object, string } from "yup";
import { nonEmptyString } from "@covertree/utils";

import { SourceOfDamageWater } from "@api/operations.generated";
import { YesNo } from "@covertree/types";

export interface WaterDamageSourceForm {
  claimType: SourceOfDamageWater;
  claimDescription: string;
  isDamageFixed: YesNo;
}

export const validation = object({
  claimType: string().required("Source of Damage is required"),
  claimDescription: nonEmptyString("Claim description").max(
    3000,
    "Claim description is too long"
  ),
  isDamageFixed: mixed<YesNo>()
    .oneOf(Object.values(YesNo), "Answer to the marked question is required")
    .required(),
});
